import React from 'react';
import Button from '@material-ui/core/Button';
import ChatIcon from '@material-ui/icons/Chat';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

export default function(props) {
  const classes = useStyles();
  return (<Button
        variant="contained"
        color="primary"
        size="large"
        className={classes.button}
        endIcon={<ChatIcon />}
        onClick={props.onClick}
        >
        Chat Now
      </Button>);
}
